import React, { useContext } from "react";

import { useNavigate } from "react-router-dom";
import classes from "./AdminHeader.module.scss";

import { AppContext } from "../../../context/app-context";
import { Props } from "./AdminHeader.config";

const AdminHeader: React.FC<Props> = ({
  collapsed,
  setCollapsed,
  toggled,
  setToggled,
}) => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <>
      <header className={classes.header}>
        <i
          className={`${classes.hamburger} pi pi-bars`}
          onClick={() => {
            if (appContext.isMobile) {
              setCollapsed(false);
              setToggled(!toggled);
            } else {
              setCollapsed(!collapsed);
            }
          }}
        ></i>
        <div>{appContext.user && appContext.user.fullName}</div>
        <div className={classes.rightIcons}>
          {/* 
          <i
            style={{
              border: "1px solid var(--blue-500)",
              padding: ".8rem",
              borderRadius: ".5rem",
            }}
            className="pi pi-key"
            onClick={() => navigate("changePassword")}
            title="Şifre Değiştir"
          ></i>*/}
          <i
            style={{
              border: "1px solid var(--red-500)",
              padding: ".8rem",
              borderRadius: ".5rem",
            }}
            className="pi pi-sign-out"
            onClick={() => {
              appContext.LogoutHandler();
              console.log("çıkış yapıldı");
            }}
            title="Çıkış"
          ></i>
        </div>
      </header>
    </>
  );
};

export default AdminHeader;
